import { isProdEnv } from 'helper';

interface NavigationItem {
  name: string;
  url: string;
}

const SITE_NAVIGATION_ITEMS: NavigationItem[] = [
  {
    name: 'Remote Jobs',
    url: 'https://remote.co/remote-jobs',
  },
  {
    name: 'Remote Companies',
    url: 'https://remote.co/qa-leading-remote-companies',
  },
  {
    name: 'Remote Work Articles',
    url: 'https://remote.co/blog',
  },
  {
    name: 'Remote Worker Q&A',
    url: 'https://remote.co/remote-workers',
  },
];

export const getSiteNavigationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'SiteNavigationElement',
  '@id': 'https://remote.co/#sitenavigation',
  name: SITE_NAVIGATION_ITEMS.map((item) => item.name),
  position: SITE_NAVIGATION_ITEMS.map((_, index) => index + 1),
  url: SITE_NAVIGATION_ITEMS.map((item) => item.url),
});

export const SiteNavigationSchemaScript = () => (
  <script
    type="application/ld+json"
    key="site-navigation"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(
        getSiteNavigationSchema(),
        null,
        isProdEnv ? 0 : 2
      ),
    }}
  />
);
